/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect, useReducer, useRef, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { Box, fade } from '@material-ui/core';
import DateNavigatorReports from '../../components/filters/DateNavigatorReports';
import { bgimage } from '../constants';
import PageLayout from '../shared/PageLayout';
import PopupFormOperationView from '../shared/PopupFormOperationView';
import TabsList from '../components/TabsList';
import useCompany from '../../hooks/useCompany';
import { getStoreItem, setStoreItem } from '../../store';
import {
  CustomerContext,
  customerReducer,
  initCustomerContext,
} from '../../contexts/managment';
import {
  initReceiptContext,
  initSalesContext,
  ReceiptContext,
  receiptReducer,
  SalesContext,
  salesReducer,
} from '../../contexts';
import Customers from '../shared/Customers';
import Invoices from './Invoices';
import Receipt from './Receipt';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Requests from './Requests';

export default function SalesOperations({
  isRTL,
  words,
  user,
  theme,
  menuitem,
  formgroup,
  drawerWidth,
}: any) {
  const [start, setStart] = useState<any>(null);
  const [end, setEnd] = useState<any>(null);

  const [item, setItem] = useState(null);
  const [openItem, setOpenItem] = useState(false);

  const { pathname } = useLocation();
  const navigate = useNavigate();

  const invoiceref: any = useRef();
  const receiptref: any = useRef();
  const customerref: any = useRef();
  const reqstref: any = useRef();

  const [currentViewName, setCurrentViewName] = useState('Month');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const { height, width } = useWindowDimensions();
  const { company } = useCompany();

  const salesStoreState = getStoreItem('salesStore', initSalesContext);
  const [salesStore, salesDispatch] = useReducer(
    salesReducer,
    salesStoreState ? salesStoreState : initSalesContext
  );
  useEffect(() => {
    setStoreItem('salesStore', salesStore);
  }, [salesStore]);

  const receiptStoreState = getStoreItem('receiptStore', initReceiptContext);
  const [receiptStore, receiptDispatch] = useReducer(
    receiptReducer,
    receiptStoreState ? receiptStoreState : initReceiptContext
  );
  useEffect(() => {
    setStoreItem('receiptStore', receiptStore);
  }, [receiptStore]);

  const customerStoreState = getStoreItem('customerStore', initCustomerContext);
  const [customerStore, customerDispatch] = useReducer(
    customerReducer,
    customerStoreState ? customerStoreState : initCustomerContext
  );
  useEffect(() => {
    setStoreItem('customerStore', customerStore);
  }, [customerStore]);

  const currentViewNameChange = (e: any) => {
    setCurrentViewName(e.target.value);
  };

  const currentDateChange = (curDate: any) => {
    setCurrentDate(curDate);
  };

  const endDateChange = (curDate: any) => {
    setEndDate(curDate);
  };

  const onCloseItem = () => {
    setOpenItem(false);
    setItem(null);
  };

  const handleSelect = (item: any) => {
    navigate(item?.path);
  };

  const refresh = () => {
    if (pathname?.includes('invoices')) {
      invoiceref?.current?.refresh();
    }
    if (pathname?.includes('receipts')) {
      receiptref?.current?.refresh();
    }
    if (pathname?.includes('customers')) {
      customerref?.current?.refresh();
    }
    if (pathname?.includes('requests')) {
      reqstref?.current?.refresh();
    }
  };

  const bgcolor = '#23A46C08';

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      theme={theme}
      refresh={refresh}
      bgcolor={bgcolor}
      bgimage={bgimage}
      width={width - drawerWidth}
    >
      <Box
        style={{
          height: height - 50,
          overflow: 'auto',
        }}
      >
        <Box
          display="flex"
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginRight: 50,
            marginLeft: 50,
            marginTop: 5,
          }}
        >
          <DateNavigatorReports
            setStart={setStart}
            setEnd={setEnd}
            currentDate={currentDate}
            currentDateChange={currentDateChange}
            currentViewName={currentViewName}
            currentViewNameChange={currentViewNameChange}
            endDate={endDate}
            endDateChange={endDateChange}
            views={[1, 7, 30, 365, 1000]}
            isRTL={isRTL}
            words={words}
            theme={theme}
          ></DateNavigatorReports>
        </Box>
        <Paper
          elevation={5}
          style={{
            borderRadius: 25,
            margin: 25,
            marginTop: 5,
            width: width - drawerWidth - 50,
            height: height - 135,
          }}
        >
          <TabsList
            handleSelect={handleSelect}
            isRTL={isRTL}
            list={formgroup}
            theme={theme}
            width={width - drawerWidth - 50}
            color={fade(theme?.palette?.secondary?.main, 0.2)}
            pathname={pathname}
          ></TabsList>
          <Paper
            style={{
              display: 'flex',
              height: height - 185,
              overflow: 'auto',
              borderBottomLeftRadius: 25,
              borderBottomRightRadius: 25,
            }}
          >
            <Routes>
              <Route
                index
                element={<Navigate to={formgroup?.[0]?.path} replace />}
              />
              <Route
                path={'requests'}
                element={
                  <Requests
                    ref={reqstref}
                    isRTL={isRTL}
                    start={start}
                    end={end}
                    words={words}
                    theme={theme}
                    company={company}
                    drawerWidth={drawerWidth}
                  ></Requests>
                }
              />
              <Route
                path={'invoices'}
                element={
                  <SalesContext.Provider
                    value={{ state: salesStore, dispatch: salesDispatch }}
                  >
                    <Invoices
                      ref={invoiceref}
                      start={start}
                      end={end}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                      drawerWidth={drawerWidth}
                    ></Invoices>
                  </SalesContext.Provider>
                }
              />
              <Route
                path={'receipts'}
                element={
                  <ReceiptContext.Provider
                    value={{ state: receiptStore, dispatch: receiptDispatch }}
                  >
                    <Receipt
                      ref={receiptref}
                      start={start}
                      end={end}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                      drawerWidth={drawerWidth}
                    ></Receipt>
                  </ReceiptContext.Provider>
                }
              />
              <Route
                path={'customers'}
                element={
                  <CustomerContext.Provider
                    value={{ state: customerStore, dispatch: customerDispatch }}
                  >
                    <Customers
                      ref={customerref}
                      isRTL={isRTL}
                      words={words}
                      theme={theme}
                      company={company}
                    ></Customers>
                  </CustomerContext.Provider>
                }
              />
            </Routes>
          </Paper>
        </Paper>
        <PopupFormOperationView
          open={openItem}
          onClose={onCloseItem}
          row={item}
          theme={theme}
          isRTL={isRTL}
          words={words}
          user={user}
        ></PopupFormOperationView>
      </Box>
    </PageLayout>
  );
}
